import React from 'react'
import LoadingPage from 'components/LoadingPage'
import Suspense from 'components/Suspense'
import CodeTestBrowser from './CodeTestBrowser'

export interface ICodeTestBrowserContainerProps {
  disabled?: boolean
}

const CodeTestBrowserContainer = (props: ICodeTestBrowserContainerProps) => {
  return (
    <Suspense fallback={<LoadingPage />}>
      <CodeTestBrowser
        {...props}
      />
    </Suspense>
  )
}

export default React.memo(CodeTestBrowserContainer)
